import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "./ProductList.css";

const BASE_URL = "https://dashboard.jyotirvani.com";

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  const categoryName = location.state?.categoryName || "";

  useEffect(() => {
    setLoading(true);

    axios
      .get(`${BASE_URL}/api/fetchproduct`)
      .then((res) => {
        const imagePath = `${BASE_URL}/uploads/productImage/`;

        const list = Array.isArray(res.data?.data)
          ? res.data.data
          : [];

        const allProducts = list.map((p) => ({
          ...p,
          image: p.image
            ? imagePath + p.image
            : `${BASE_URL}/uploads/defaultImage/defaultImage.png`,
          price: p.price ? Number(p.price) : 0,
        }));

        const filtered = categoryName
          ? allProducts.filter(
              (p) =>
                p.category?.toLowerCase().trim() ===
                categoryName.toLowerCase().trim()
            )
          : allProducts;

        setProducts(filtered);
      })
      .catch((err) => {
        console.log(err);
        setError("Failed to load products");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [categoryName]);

  const filteredProducts = products.filter((product) =>
    product.name
      ?.toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  if (loading) {
    return (
      <p className="ra-shop-status">
        Loading...
      </p>
    );
  }

  if (error) {
    return (
      <p className="ra-shop-status ra-shop-error">
        {error}
      </p>
    );
  }

  return (
    <div className="ra-main-shop">
      <div className="container">

        <div className="ra-shop-top-section">
          <h2 className="ra-shop-page-title">
            {categoryName
              ? `${categoryName} Products`
              : "Our Products"}
          </h2>

          <p className="ra-shop-page-subtitle">
            Explore premium spiritual products with a modern shopping experience
          </p>
        </div>

        <div className="ra-shop-search-bar">
          <input
            type="text"
            placeholder={`Search ${
              categoryName || "Product"
            }`}
            value={searchQuery}
            onChange={(e) =>
              setSearchQuery(e.target.value)
            }
          />

          <button
            className="ra-shop-search-btn"
            onClick={() => setSearchQuery("")}
            type="button"
          >
            🔍
          </button>
        </div>

        <div className="row">

          {filteredProducts.length > 0 ? (
            filteredProducts.map((product) => (
              <div
                key={product.id}
                className="col-lg-3 col-md-4 col-sm-6 col-6"
              >
                <div
                  className="ra-shop-product-card"
                  onClick={() =>
                    navigate(`/product/${product.id}`)
                  }
                >

                  <div className="ra-shop-product-image-wrap">
                    <img
                      src={product.image}
                      alt={product.name}
                    />
                  </div>

                  <div className="product-info">

                    <p className="ra-shop-product-name">
                      {product.name}
                    </p>

                    {/* PRICE */}
                    {/* 
                    <p className="ra-shop-price">
                      ₹{product.price}
                    </p> 
                    */}

                  </div>

                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <p className="ra-shop-status">
                No products found.
              </p>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default ProductList;